<div class="scrollable">

  <div class="panel">
    @if(isExpired){
    <div class="alert alert-danger d-flex align-items-center gap-2 mb-0 rounded-0 py-2">
      <i class="fas fa-ban"></i>
      <span class="small">El período de carga ha expirado. No es posible modificar respuestas ni adjuntar evidencia.</span>
    </div>
    }
    <div class="panel-heading bg-blue-700 d-flex justify-content-between align-items-center flex-wrap gap-2">
      <span class="text-white fs-6 fw-600"><i class="fas fa-file-alt fa-fw"></i>{{certpro?.period.group.name}} </span>
      <span class="text-white fs-6 fw-600"><i class="fas fa-calendar-alt fa-fw"></i>Periodo: {{$safeNavigationMigration(certpro?.period.period) |
        date: 'MM-yyyy'}}</span>
      <span class="text-white fs-6 fw-600"><i class="fas fa-list-check fa-fw"></i>Puntaje: <span
          class="badge rounded-pill bg-{{certpro?.period.score < 50 ? 'danger': certpro?.period.score < 70 ? 'warning' : 'success'}} fs-10px">{{$safeNavigationMigration(certpro?.period.score)
          | number: "1.0-2" }}</span></span>
      <span class="text-white fs-6 fw-600"><i class="fas fa-user-secret fa-fw"></i> Auditor:
        {{certpro?.period.auditor ? certpro?.period.auditor.displayName : ' No asignado'}} </span>
      <span class="text-white fs-6 fw-600"><i class="fas fa-hourglass-end fa-fw"></i> Límite: {{certpro?.period.expiration | date: 'dd-MM-yyyy'}}</span>

    </div>
    <div class="p-4">
      <div class="accordion" id="accordion">
        @for(evaluation of certpro?.evaluation; track $index; let categoryIndex = $index){
        <div class="accordion-item border-0 mb-2">
          <div class="accordion-header" [id]="'heading' + categoryIndex">

            <button class="accordion-button bg-gray-300 text-black px-3 py-10px pointer-cursor btn-accordion collapsed"
              (click)="toggleCategory(categoryIndex)">
              <div class="d-flex justify-content-between align-items-center w-100 pr-3">

                <span class="fw-700">{{ categoryIndex + 1 }} - {{ evaluation.category.name | uppercase }}
                  @if(evaluation.category.tooltip){<i class="fas fa-info-circle"
                    [ngbTooltip]="evaluation.category.tooltip"></i>}</span>
                <div class="d-flex align-items-center gap-2">
                  <div class="progress bg-gray-500 h-8px w-120px mb-0">
                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                      [ngClass]="{'bg-red': evaluation.category.completed < 30, 'bg-yellow': evaluation.category.completed >= 30 && evaluation.category.completed <50, 'bg-orange': evaluation.category.completed >= 50 && evaluation.category.completed <70, 'bg-green': evaluation.category.completed >= 70}"
                      [style.width.%]="evaluation.category.completed">
                    </div>
                  </div>
                  <span class="fw-600 ms-1 min-w-45px text-end">{{evaluation.category.completed | number: "1.0-0"}}%</span>
                </div>

              </div>
            </button>

          </div>

          <div [id]="'collapse' + categoryIndex" class="accordion-collapse collapse"
            [ngClass]="{ 'show': activeCategory === categoryIndex }"
            [attr.aria-labelledby]="'heading' + categoryIndex">

            <div class="accordion-body bg-gray-100 text-black p-0">
              <div class="table-wrapper">
                <div class="left-bar"></div>
                <table class="table table-bordered table-side gx-4 mb-0">
                  <thead class="table-light">
                    <tr>
                      <th class="col-item">Item</th>
                      <th>Criterio</th>
                      <th class="text-center col-answer">Respuesta</th>
                      <th class="text-center col-evidence">Evidencia</th>
                      <th class="text-center col-progress">Progreso</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for(item of evaluation.answers; track $index; let iitem = $index){
                    <tr class="item-row" [ngClass]="{'has-subitems': item.subitems.length > 0}">
                      <td [style.paddingLeft.px]="10" class="fw-600"> {{ categoryIndex + 1 }}.{{ iitem + 1 }}</td>
                      <td>
                        <span class="fw-500">{{ item.question.title}}</span>
                        @if(item.question.tooltip){
                        <span class="ms-2 tip-circle bg-info text-white" [ngbTooltip]="item.question.tooltip" placement="top" container="body">?</span>
                        }
                      </td>
                      @if(item.subitems.length > 0){
                      <td colspan="2"></td>

                      <td class="text-center">
                        <div class="d-flex align-items-center justify-content-center gap-1">
                          <div class="progress bg-gray-600 h-6px w-80px mb-0">
                            <div class="progress-bar progress-bar-striped"
                              [ngClass]="{'bg-red': (!item.question.completed || item.question.completed === 0),
                                 'bg-orange': item.question.completed > 0 && item.question.completed < 100,
                                 'bg-green': item.question.completed >= 100}"
                              [style.width.%]="item.question.completed || 0">
                            </div>
                          </div>
                          <small class="ms-1 text-muted fw-500">{{item.question.completed | number: "1.0-0"}}%</small>
                        </div>
                      </td>
                      }@else{
                      <td class="text-center">
                        @if(review || isExpired){
                        <span class="badge fs-12px" [ngClass]="item.answer ? 'bg-success' : 'bg-secondary'">{{ item.answer == null ? '—' : item.answer ? 'SI' : 'NO' }}</span>
                        }@else{
                        <select class="form-select form-select-sm bg-white text-center fw-500" [(ngModel)]="item.answer"
                          (ngModelChange)="updateAnswer(item)">
                          <option [ngValue]="null">Seleccione...</option>
                          <option [ngValue]="false">NO</option>
                          <option [ngValue]="true">SI</option>
                        </select>
                        }
                      </td>
                      <td class="text-center">
                        <div class="evidence-status d-flex align-items-center justify-content-center gap-1">
                          @if(item.fileId || item.file){
                          <button class="btn btn-outline-dark px-2" (click)="viewFile(modalViewFile, item)" [ngbTooltip]="'Ver evidencia adjunta'">
                            <i class="fas fa-file-alt"></i>
                          </button>
                          }
                          @if(item.answer != null && !review && !isExpired){
                          <button class="btn btn-outline-dark px-2"
                            (click)="openEvidencePanel(item)" [ngbTooltip]="'Adjuntar o editar evidencia'">
                            <i class="fas fa-paperclip"></i>
                          </button>
                          }@else if(item.answer == null && !review){
                          <span class="text-muted small">—</span>
                          }
                          @if(review && (item.fileId || item.comments)){
                          <button class="btn btn-outline-dark px-2" (click)="viewFile(modalViewFile, item)" [ngbTooltip]="'Ver evidencia'">
                            <i class="fas fa-eye"></i>
                          </button>
                          }
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="d-flex align-items-center justify-content-center gap-1">
                          <div class="progress bg-gray-600 h-6px w-80px mb-0">
                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                              [ngClass]="{'bg-red': item.answer == null,
                                 'bg-orange': item.answer != null && !item.file && !item.comments,
                                 'bg-green': item.answer != null && (item.file || item.comments)}"
                              [style.width.%]="item.answer != null ? (item.file || item.comments ? 100 : 50) : 0">
                            </div>
                          </div>
                          <small class="ms-1 text-muted fw-500">{{item.answer != null ? (item.file || item.comments ? '100' : '50') : '0'}}%</small>
                        </div>
                      </td>
                      }
                    </tr>

                    @for(subitem of item.subitems; track subitem; let isubitem = $index){
                    <tr class="subitem-row">
                      <td [style.paddingLeft.px]="30" class="text-muted"> {{ categoryIndex + 1 }}.{{ iitem + 1 }}.{{ isubitem + 1 }}
                      </td>
                      <td>
                        <span class="fw-500">{{ subitem.question.title }}</span>
                        @if(subitem.question.tooltip){
                        <span class="ms-2 tip-circle bg-info text-white" [ngbTooltip]="subitem.question.tooltip" placement="top" container="body">?</span>
                        }
                      </td>

                      <td class="text-center">
                        @if(review || isExpired){
                        <span class="badge fs-12px" [ngClass]="subitem.answer ? 'bg-success' : 'bg-secondary'">{{ subitem.answer ? 'SI' : 'NO' }}</span>
                        }@else{
                        <select class="form-select form-select-sm bg-white text-center fw-500" [(ngModel)]="subitem.answer"
                          (ngModelChange)="updateAnswer(subitem)">
                          <option [ngValue]="null">Seleccione...</option>
                          <option [ngValue]="false">NO</option>
                          <option [ngValue]="true">SI</option>
                        </select>
                        }

                      </td>
                      <td class="text-center">
                        <div class="evidence-status d-flex align-items-center justify-content-center gap-1">
                          @if(subitem.fileId || subitem.file){
                          <button class="btn btn-outline-dark px-2" (click)="viewFile(modalViewFile, subitem)" [ngbTooltip]="'Ver evidencia adjunta'">
                            <i class="fas fa-file-alt"></i>
                          </button>
                          }
                          @if(subitem.answer != null && !review && !isExpired){
                          <button class="btn btn-outline-dark px-2"
                            (click)="openEvidencePanel(subitem)" [ngbTooltip]="'Adjuntar o editar evidencia'">
                            <i class="fas fa-paperclip"></i>
                          </button>
                          }@else if(subitem.answer == null && !review){
                          <span class="text-muted small">—</span>
                          }
                          @if(review && (subitem.fileId || subitem.comments)){
                          <button class="btn btn-outline-dark px-2" (click)="viewFile(modalViewFile, subitem)" [ngbTooltip]="'Ver evidencia'">
                            <i class="fas fa-eye"></i>
                          </button>
                          }
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="d-flex align-items-center justify-content-center gap-1">
                          <div class="progress bg-gray-600 h-6px w-80px mb-0">
                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                              [ngClass]="{'bg-red': subitem.answer == null,
                                 'bg-orange': subitem.answer != null && !subitem.file && !subitem.comments,
                                 'bg-green': subitem.answer != null && (subitem.file || subitem.comments)}"
                              [style.width.%]="subitem.answer != null ? (subitem.file || subitem.comments ? 100 : 50) : 0">
                            </div>
                          </div>
                          <small class="ms-1 text-muted fw-500">{{subitem.answer != null ? (subitem.file || subitem.comments ? '100' : '50') : '0'}}%</small>
                        </div>
                      </td>
                    </tr>
                    }
                    }
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
        }
      </div>
      <div class="d-flex justify-content-between mt-4 pt-3 border-top">
        @if(review){
        <button class="btn btn-outline-secondary" (click)="back()">
          <i class="fas fa-arrow-left"></i> Volver
        </button>
        }
        @if(certpro?.period.enabled){
        <div class="ms-auto d-flex gap-2">
          @if(certpro?.period.realized == null){
          <button class="btn btn-primary" (click)="finish()">
            <i class="fas fa-check-circle"></i> Completar
          </button>
          }
          @if(certpro?.period.realized){
          <button class="btn btn-success" (click)="validate()">
            <i class="fas fa-check-double"></i> Validar
          </button>
          }
        </div>
        }
      </div>
    </div>
  </div>

</div>

<div class="offcanvas offcanvas-end" [ngClass]="{'show': evidenceOpen}" tabindex="-1">
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title">
      @if(evidenceItem?.answer){
      <i class="fas fa-file me-2"></i>Adjuntar evidencia
      }@else if(evidenceItem?.answer != null){
      <i class="fas fa-comment me-2"></i>Motivo
      }
    </h5>
    <button type="button" class="btn-close" (click)="closeEvidencePanel()"></button>
  </div>
  <div class="offcanvas-body">
    @if(isExpired){
    <div class="text-center text-muted py-4">
      <i class="fas fa-ban fa-2x mb-2"></i>
      <p class="small mb-0">Período expirado. No es posible modificar evidencia.</p>
    </div>
    }@else if(evidenceItem?.answer){
    <div class="mb-3">
      <label class="form-label fw-500">Seleccione un archivo</label>
      @if(evidenceItem?.fileId || evidenceItem?.file){
      <div class="alert alert-info d-flex align-items-center gap-2 py-2">
        <i class="fas fa-paperclip"></i>
        <span class="small flex-grow-1">{{evidenceItem?.file?.originalName || 'Archivo actual'}}</span>
        <button class="btn btn-sm btn-outline-primary" (click)="viewFile(modalViewFile, evidenceItem); closeEvidencePanel()">
          <i class="fas fa-eye"></i>
        </button>
      </div>
      <p class="small text-muted mb-2">Sube un nuevo archivo para reemplazar el actual:</p>
      }
      <input type="file" class="form-control"
        (change)="uploadFile(evidenceItem, $any($event.target).files[0])"
        accept=".pdf,.doc,.docx,.jpg,.png,.xlsx,.xls">
      <span class="text-muted small d-block mt-1">PDF, DOC, JPG, PNG, XLS</span>
    </div>
    }@else if(evidenceItem?.answer != null){
    <div class="mb-3">
      <label class="form-label fw-500">Motivo</label>
      @if(evidenceItem?.comments && !editingComment){
      <div class="bg-light border rounded p-2 mb-2">
        <small class="text-muted d-block mb-1">Motivo actual:</small>
        <p class="mb-0 small">{{evidenceItem.comments}}</p>
      </div>
      <button class="btn btn-sm btn-outline-primary" (click)="startEditComment()">
        <i class="fas fa-pen me-1"></i>Editar motivo
      </button>
      }
      @if(!evidenceItem?.comments || editingComment){
      <textarea class="form-control" rows="4" [(ngModel)]="evidenceItem.comments"
        placeholder="Describa el motivo..."></textarea>
      <div class="d-flex gap-2 mt-2">
        <button class="btn btn-success" (click)="saveComment(evidenceItem)">
          <i class="fas fa-check me-1"></i>Guardar
        </button>
        @if(evidenceItem?.comments){
        <button class="btn btn-outline-secondary" (click)="cancelEditComment()">
          Cancelar
        </button>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
@if(evidenceOpen){
<div class="offcanvas-backdrop fade show" (click)="closeEvidencePanel()"></div>
}

<ng-template #modalViewFile let-c="close" let-d="dismiss">
  <div class="modal-header">
    <span class="fs-5 fw-700">
      @if(item.fileId || item.file){
      <i class="fas fa-file-alt me-2"></i>Evidencia
      }@else{
      <i class="fas fa-comment me-2"></i>Motivo
      }
    </span>
    <button type="button" class="btn-close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    @if(item.fileId || item.file){
    <div class="border rounded p-2 bg-light">
      <universal-viewer [blob]="blob"></universal-viewer>
    </div>
    }@else {
    <p class="text-muted mb-0">{{item.comments || 'Sin comentarios'}}</p>
    }
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <button class="btn btn-outline-primary" (click)="downloadFile()"><i class="fas fa-download"></i> Descargar</button>
    <button class="btn btn-secondary" (click)="d('Cross click')">Cerrar</button>
  </div>
</ng-template>
